// tzdata 2026b-e: BC, Alberta and Manitoba stop changing clocks on 2026-11-01.
// luxon gets these zones in every browser: stale tz data gives the old offsets, and some
// browsers with current offsets still label these zones PDT/MDT/CDT.
import { FixedOffsetZone, IANAZone, Settings, SystemZone, Zone } from "luxon"

const RULES = {
  "America/Vancouver": { cutover: Date.UTC(2026, 10, 1, 9), offset: -420, short: "MST", long: "Mountain Standard Time" },
  "America/Edmonton": { cutover: Date.UTC(2026, 10, 1, 8), offset: -360, short: "CST", long: "Central Standard Time" },
  "America/Winnipeg": { cutover: Date.UTC(2026, 10, 1, 7), offset: -300, short: "EST", long: "Eastern Standard Time" },
}

class PermanentTimeZone extends Zone {
  constructor(native, rule) {
    super()
    this.native = native
    this.rule = rule
  }

  // Not 'iana', so luxon formats through offset() instead of passing the name to Intl.
  get type() { return "canada-permanent-time" }

  get name() { return this.native.name }

  get isUniversal() { return false }

  get isValid() { return true }

  offset(ts) { return ts < this.rule.cutover ? this.native.offset(ts) : this.rule.offset }

  offsetName(ts, opts) {
    if (ts < this.rule.cutover) return this.native.offsetName(ts, opts)
    return opts && opts.format === "long" ? this.rule.long : this.rule.short
  }

  formatOffset(ts, format) { return FixedOffsetZone.instance(this.offset(ts)).formatOffset(ts, format) }

  // Compares the type as well as the name: luxon's SystemZone has the device's IANA name,
  // and setZone does nothing when the new zone equals the current one.
  equals(other) { return other.type === this.type && other.name === this.name }
}

// DateTime.now() and zone-less parses use the device zone, which skips IANAZone.create.
export function applyToDeviceZone(deviceZone) {
  const zone = RULES[deviceZone] && IANAZone.create(deviceZone)
  if (zone instanceof PermanentTimeZone) Settings.defaultZone = zone
}

export default function installCanadaPermanentTime() {
  if (IANAZone.create.canadaPermanentTime) return
  const nativeCreate = IANAZone.create.bind(IANAZone)
  // One wrapper per zone, created on first use.
  const wrappers = {}
  const create = (name) => {
    const native = nativeCreate(name)
    const rule = RULES[native.name]
    if (!rule) return native
    if (!wrappers[native.name]) wrappers[native.name] = new PermanentTimeZone(native, rule)
    return wrappers[native.name]
  }
  create.canadaPermanentTime = true
  IANAZone.create = create
  applyToDeviceZone(SystemZone.instance.name)
}
